/**
 * src/components/funnel/FunnelLayout.jsx
 *
 * Header, page, footer — plus the scroll-reveal observer, which every funnel
 * page needs and none should have to remember to wire up.
 *
 * `announcement` and `mailingList` are off on the application and its outcome
 * pages: once someone is mid-application, a banner selling the thing they are
 * already applying for is a distraction, and an email-capture form under a
 * form they are filling in competes with it.
 */

import React from "react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import useReveal from "../../lib/useReveal";

export default function FunnelLayout({
  announcement = true,
  mailingList = true,
  children,
}) {
  useReveal();

  return (
    <div className="min-h-screen bg-ink-900 text-[color:var(--rp-body)]">
      <SiteHeader announcement={announcement} />
      <main>{children}</main>
      <SiteFooter mailingList={mailingList} />
    </div>
  );
}
